import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { styled, Typography } from "@mui/material";
import { AppWrap } from "../common/commonComps";
import type { AppContext } from "../types";

const Iframe = styled(`iframe`)(() => ({
    width: `100%`,
    overflow: `hidden`,
    border: `none`,
}));

const receiveIframeHeight = (event: MessageEvent<{ type: string; height: number }>) => {
    if (event.data.type === `iframeHeight`) {
        const iframe = document.querySelector<HTMLIFrameElement>(`#contentframe`);
        iframe!.style.setProperty(`height`, `${event.data.height}px`);
    }
};

const InfoPage = ({ context }: { context: AppContext }) => {
    const { page } = useParams();

    useEffect(() => {
        window.addEventListener(`message`, receiveIframeHeight);
        return () => window.removeEventListener(`message`, receiveIframeHeight);
    }, []);

    return (
        <AppWrap id="appwrap">
            {!context.adminConfig?.mall?.[`${page}_page_url`] && (
                <Typography sx={{ textAlign: `center`, paddingTop: `200px` }} variant="h6" gutterBottom>
                    The content for this page is currently unavailable.
                </Typography>
            )}
            <Iframe
                id="contentframe"
                title="contentframe"
                src={context.adminConfig?.mall?.[`${page}_page_url`] as string}
            />
        </AppWrap>
    );
};

export default InfoPage;
